import React from "react";
import Header from "./Header";
import PublicHeader from "./PublicHeader";
import { useGuestAuth } from "../context/GuestAuthContext";

/**
 * Session-aware chrome: authenticated users get the full nav (messages,
 * listings, sell); guests get Sign In / Sign Up so they can browse publicly
 * without messaging affordances.
 */
export default function AppHeader() {
  const { isGuest, openSignIn, openSignUp } = useGuestAuth();

  if (!isGuest) {
    return <Header />;
  }

  return <PublicHeader onSignInClick={openSignIn} onSignUpClick={openSignUp} />;
}
